// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33-UU","colBig":"styles_colBig__2WAkx","colSmall":"styles_colSmall__2DLxW"};